// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1afe0","col":"styles_col__1zsqn"};